import { useMutation, useQueryClient } from '@tanstack/react-query';
import { subscriptionService } from '../../../services/subscription';
import { toast } from 'react-toastify';
import { useTranslation } from '@hooks/useTranslation';

export const useDeletePaymentMethod = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (paymentMethodId: string) =>
      subscriptionService.deletePaymentMethod(paymentMethodId),
    onSuccess: (result) => {
      queryClient.invalidateQueries({ queryKey: ['paymentMethods'] });
      if (result.warning) {
        toast.warning(result.warning);
      } else {
        toast.success(tActionMessages.paymentMethodDeletedSuccessfully);
      }
    },
    onError: (error: any) => {
      toast.error(error?.response?.errors?.[0]?.message || tActionMessages.failedToDeletePaymentMethod);
    },
  });
};
